import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing

export default function ServicesPage({ services }) {
  return (
    <>

      {/* Services Page Start */}
      <section className="services-page">

        <div className="container" >
          <h1 className='service-details__title-one'>Explore Wide Range of Scrap Processing Machineries</h1>
          <div className="row">
            {services.map((service, index) => (

              <div key={index} className="col-xl-4">
                <div className="services-one__single border" style={{ color: "#52515E", borderRadius: '20px', gap: '5px' }}>
                  <Link to={service.link}><div className="services-one__img-box">
                    <div className="services-one__img">
                      <img src={service.imgSrc} alt={service.title} />
                    </div>
                    {/* <div className="services-one__icon">
                      <span className={service.iconClass} />
                    </div> */}
                  </div>
                    <div className="services-one__content">
                      <h3 className="services-one__title">
                        <Link to={service.link}>{service.title}</Link>
                      </h3>
                      <p className="services-one__text" style={{ color: "#52515e" }}>{service.description}</p>
                      <div className="services-one__btn-box">
                        <Link to={service.link} className="services-one__btn thm-btn">
                          Read more
                          <span className="icon-dubble-arrow-right" />
                        </Link>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Services Page End */}
    </>
  );
}
